import React from 'react';

export const RoleCell = (value: any) => {
  let role = '';
  switch (value) {
    case 0:
      role = 'Водій';
      break;
    case 1:
      role = 'Експедитор';
      break;
    case 2:
      role = 'Автомобіль';
      break;
    case 3:
      role = 'Причеп';
      break;
    default:
      role = '';
  }
  return <React.Fragment>{role}</React.Fragment>;
};
